import { jsx as _jsx } from "react/jsx-runtime";
import Button from '@jetbrains/ring-ui/components/button/button';
import classNames from 'classnames';
import tableStyles from './basic-table-view.css';
export function TableActionButton({ className, action, onKeyDown, ...restProps }) {
    return (_jsx(Button, { className: classNames(tableStyles.tableHoverAction, tableStyles.tableActionButton, className), onClick: action, onKeyDown: evt => {
            if (evt.keyCode === 13) {
                evt.stopPropagation();
                evt.preventDefault();
                action();
            }
            if (onKeyDown) {
                onKeyDown(evt);
            }
        }, ...restProps }));
}
